import { BaseService } from "../BaseService";

export interface ImportMapping {
  id: number;
  tenant_id: number;
  name: string;
  entity_name: string;
  mapping_json: string;
  created_at: string;
  updated_at: string;
}

export interface ImportJob {
  id: number;
  tenant_id: number;
  entity_name: string;
  file_id: number;
  import_mapping_id?: number | null;
  mapping_json: string;
  status: string;
  total_records?: number | null;
  processed_records?: number | null;
  failed_records?: number | null;
  error_message?: string | null;
  log?: string | null;
  created_at: string;
  updated_at: string;
}

export class ImportService extends BaseService {
  public async getMappings(): Promise<ImportMapping[]> {
    return this.getRequest("/imports/mappings");
  }

  public async getMappingById(id: number): Promise<ImportMapping> {
    return this.getRequest(`/imports/mappings/${id}`);
  }

  public async createMapping(data: {
    name: string;
    entity_name: string;
    mapping_json: string;
  }): Promise<ImportMapping> {
    return this.postRequest("/imports/mappings", data, "Import mapping created");
  }

  public async updateMapping(
    id: number,
    data: { name?: string; mapping_json?: string }
  ): Promise<ImportMapping> {
    return this.putRequest(`/imports/mappings/${id}`, data, "Import mapping updated");
  }

  public async deleteMapping(id: number): Promise<void> {
    return this.deleteRequest(`/imports/mappings/${id}`, "Import mapping deleted");
  }

  public async getJobs(): Promise<ImportJob[]> {
    return this.getRequest("/imports/jobs");
  }

  public async getJobById(id: number): Promise<ImportJob> {
    return this.getRequest(`/imports/jobs/${id}`);
  }

  public async createJob(data: {
    entity_name: string;
    file_id: number;
    import_mapping_id?: number | null;
    mapping_json?: string | null;
  }): Promise<ImportJob> {
    return this.postRequest("/imports/jobs", data, "Import job started");
  }
}

export const importService = new ImportService();
export default importService;
